import React, { Component } from 'react'
import FilterActiveIcon from "../../icons/filteractiveicon";
import FilterIcon from "../../icons/filtericon";
import serachIcon from "../../assets/images/search.svg";
import moment from 'moment-timezone'
import ReactPaginate from "react-paginate";
import TextField from './../../component/TextField';
import service from '../../services';
import DatePicker from 'react-datepicker';
import CalendarIcon from '../../icons/calendaricon';
import Loader from '../loader';
import _ from 'lodash'
let description
let sub;
let roleWiseFilterData = [];
let itemsWiseFilterData = [];
let screeningTypeFilterData = [];
let sourceFilterData = [];
export default class ScreeningUser extends Component {
    constructor(props) {
        super(props)
        this.state = {
            getAllScreeningReport: [],
            searchField: '',
            // pagination variable diclaration start
            offset: 0,
            perPage: 50,
            currentPage: 0,
            // pagination variable diclaration end
            rolesType: [
                { assign: "sioUser", name: "Industry", value: false },
                { assign: "pressUser", name: "Press", value: false },
                // {assign:"circleUser", name:"Sundance Circle",value:false},
                { assign: 'generalUser', name: 'General', value: false },
                { assign: 'circleGuestUser', name: 'Sundance Guest', value: false },
                { assign: 'artistUser', name: 'Artist', value: false },
            ],
            screeningType: [
                { assign: "1", name: "Premiere", value: false },
                { assign: "2", name: "Second Screening", value: false },
                { assign: "3", name: "Award Winner", value: false },
                { assign: '4', name: 'Indies Series', value: false },
                { assign: '5', name: 'Shorts', value: false },
                { assign: '6', name: 'My Library', value: false },

            ],
            sourceType: [
                { assign: true, name: "OTT", value: false },
                { assign: false, name: "Web", value: false },
            ],
            filmFilterType: []
        }
        this.apiserve = new service();
    }

    componentWillUnmount = () => {
        sub.unsubscribe();
        roleWiseFilterData = [];
        itemsWiseFilterData = [];
        screeningTypeFilterData = [];
        sourceFilterData = [];
    }


    componentDidMount = async () => {
        this.getScreeningReport(this.state.offset, this.state.perPage);
        this.setState({
            loaderFlag: true,
            setloaderFlag:true
        });
        this.apiserve.sendevent("admin|getUserScreeningFilmList", {});
        sub = this.apiserve.getevent().subscribe((response) => {

            switch (response.event) {
                case "admin|getUserScreening":
                    
                    if (!response.error) {
                        this.setState({
                            getAllScreeningReport: response.data.docs,
                            getTotalDocs: response.data.totalDocs,
                            pageCount: Math.ceil(response.data.totalDocs / this.state.perPage),
                            loaderFlag: false,
                        })
                    } else {
                        this.apiserve.error(response.data.error ? response.data.error : response.data)
                    }
                    break;
                case "admin|getUserScreeningFilmList":
                    if (!response.error) {
                        const list = _.remove(response.data, function (e) {
                            return e.name != undefined
                        });
                        this.setState({
                            filmFilterType: list
                        }, () => {
                            this.setState({
                                setloaderFlag: false,
                            })
                        })
                    } else {
                        this.apiserve.error(response.data.error ? response.data.error : response.data)
                    }
                    break;
                default:
                    break;
            }
        });
    }


    getScreeningReport = (skip, limit) => {
        this.setState({
            loaderFlag: true
        })
        var data = {}

        if (this.state.searchField.length) {
            data.filter = this.state.searchField
        }

        if (roleWiseFilterData.length) {
            data.role = roleWiseFilterData
        }

        if (itemsWiseFilterData.length) {
            data.film = itemsWiseFilterData
        }

        if (screeningTypeFilterData.length) {
            data.screenType = screeningTypeFilterData
        }

        if (sourceFilterData.length) {
            data.source = sourceFilterData
        }
        data.page = skip
        data.limit = limit
        this.apiserve.sendevent("admin|getUserScreening", data);
    }

    //Pagination Click
    handlePageClick = (e) => {
        const selectedPage = e.selected;
        const offset = selectedPage + 1;
        this.setState(
            {
                currentPage: selectedPage,
                offset: offset,
                loaderFlag: true
            },
            () => {
                this.getScreeningReport(this.state.offset, this.state.perPage, roleWiseFilterData);
            }
        );
    };

    //role wise filter
    roleWiseFilter = (e, selectedInex, isClearRoleType = false, isClearItemType) => {
        let index = selectedInex
        let event = e && e.target && e.target.checked
        let roleList = [...this.state.rolesType]
        roleList.forEach((key, i) => {
            if (i === index) {
                roleList[i].value = event
            }
            if (isClearRoleType) {
                roleList[i].value = false
                roleWiseFilterData = []
            }

        })
        this.setState({
            ...this.state,
            rolesType: roleList,
            currentPage: 0
        }, () => {
            if (event) {
                if (index !== null) {
                    roleWiseFilterData = [...roleWiseFilterData, this.state.rolesType[index].assign];
                }
            } else {
                if (index !== null) {
                    let tempArray = roleWiseFilterData.filter((d) => d !== this.state.rolesType[index].assign);
                    roleWiseFilterData = tempArray;
                }
            }
            this.getAllItemFilter(this.state.offset, this.state.perPage);
        })
    };

    itemsTypeFilter = (e, selectedInex, isClearRoleType, isClearItemType = false) => {

        let index = selectedInex
        let event = e && e.target && e.target.checked
        let itemsList = [...this.state.filmFilterType]
        itemsList.forEach((key, i) => {
            if (i === index) {
                itemsList[i].value = event
            }
            if (isClearItemType) {
                itemsList[i].value = false
                itemsWiseFilterData = []
            }

        })
        this.setState({
            ...this.state,
            filmFilterType: itemsList,
            currentPage: 0
        }, () => {
            if (event) {
                if (index !== null) {
                    itemsWiseFilterData = [...itemsWiseFilterData, this.state.filmFilterType[index]._id];
                }
            } else {
                if (index !== null) {
                    let tempArray = itemsWiseFilterData.filter((d) => d !== this.state.filmFilterType[index]._id);
                    itemsWiseFilterData = tempArray;
                }
            }
            this.getAllItemFilter(this.state.offset, this.state.perPage);
        })
    }

    //Screening tyep filter
    screeningTypeFilter = (e, selectedInex, isClearRoleType = false, isClearItemType) => {
        
        let index = selectedInex
        let event = e && e.target && e.target.checked
        let screeningList = [...this.state.screeningType]
        screeningList.forEach((key, i) => {
            if (i === index) {
                screeningList[i].value = event
            }
            if (isClearItemType) {
                screeningList[i].value = false
                screeningTypeFilterData = []
            }

        })
        this.setState({
            
            ...this.state,
            screeningType: screeningList,
            currentPage: 0
        }, () => {
            if (event) {
                if (index !== null) {
                    screeningTypeFilterData = [...screeningTypeFilterData, this.state.screeningType[index].assign];
                }
            } else {
                if (index !== null) {
                    let tempArray = screeningTypeFilterData.filter((d) => d !== this.state.screeningType[index].assign);
                    screeningTypeFilterData = tempArray;
                }
            }
            this.getAllItemFilter(this.state.offset, this.state.perPage);
        })
    };

    //Source type filter
    sourceTypeFilter = (e, selectedInex, isClearRoleType = false, isClearItemType) => {
        let index = selectedInex
        let event = e && e.target && e.target.checked
        let sourceList = [...this.state.sourceType]
        sourceList.forEach((key, i) => {
            if (i === index) {
                sourceList[i].value = event
            }
            if (isClearItemType) {
                sourceList[i].value = false
                sourceFilterData = []
            }

        })
        this.setState({
            ...this.state,
            sourceType: sourceList,
            currentPage: 0
        }, () => {
            if (event) {
                if (index !== null) {
                    sourceFilterData = [...sourceFilterData, this.state.sourceType[index].assign];
                }
            } else {
                if (index !== null) {
                    let tempArray = sourceFilterData.filter((d) => d !== this.state.sourceType[index].assign);
                    sourceFilterData = tempArray;
                }
            }
            this.getAllItemFilter(this.state.offset, this.state.perPage);
        })
    };


    getAllItemFilter = (skip, limit) => {
        
        this.setState({ loaderFlag: true })
        var data = {
            page: 1,
            limit: 50
        }

        if (this.state.searchField.length) {
            data.filter = this.state.searchField
        }

        if (roleWiseFilterData.length) {
            data.role = roleWiseFilterData
        }

        if (itemsWiseFilterData.length) {
            data.film = itemsWiseFilterData
        }
        
        if (screeningTypeFilterData.length) {
            data.screenType = screeningTypeFilterData
        }
        if (sourceFilterData.length) {
            data.source = sourceFilterData
        }
        this.apiserve.sendevent("admin|getUserScreening", data);
    }

    //Search Data
    onSearchFilter = (e) => {
        this.setState({ loaderFlag: true })
        this.setState({
            [e.target.name]: e.target.value,
            currentPage: 0
        }, () => {
            var data = {
                page: 1,
                limit: 50,
            }
            if (this.state.searchField.length) {
                data.filter = this.state.searchField
            }
            if (roleWiseFilterData.length) {
                data.role = roleWiseFilterData
            }
            if (itemsWiseFilterData.length) {
                data.film = itemsWiseFilterData
            }
            if (screeningTypeFilterData.length) {
                data.screenType = screeningTypeFilterData
            }
            if (sourceFilterData.length) {
                data.source = sourceFilterData
            }
            this.apiserve.sendevent("admin|getUserScreening", data);
        });
    }


    render() {
        const { rolesType ,roleWiseFilter, roleWiseFilterData,screeningTypeFilter,screeningOnlineType,screeningOnlineTypeFilter,filmFilterType,itemsScreeningTypeFilter,sourceTypeFilter,sourceType}= this.props
        const { getAllScreeningReport } = this.state
        return (
            <>
                <div className="dashboard_data">
                    <table>
                        <thead>
                            <th style={{ width: "325px" }} >
                                {/* <div className="d_flex d_flex_align_center"> */}
                                    <span className="pl_25">Email</span>
                                    {/* <div class="dashboard_header no_bg p_0">
                                        <div class="searchBlock bg_white back_date p_0 ml_10">
                                            <form class="m_0">
                                                <input class="bg_white border_search" type="text" placeholder="Search" id="searchField" name="searchField" value={this.state.searchField}
                                                    onChange={this.onSearchFilter} />
                                                <button type="button" className="mr_10" ><img src={serachIcon} /></button>
                                            </form>
                                        </div>
                                    </div> */}
                                {/* </div> */}
                            </th>
                            <th style={{ width: "110px" }}><span>First Name</span></th>
                            <th style={{ width: "110px" }}><span>Last Name</span></th>
                            <th style={{ width: "120px" }}>
                                <span className="d_flex d_flex_align_center">
                                    Role
                                    {roleWiseFilterData && roleWiseFilterData.length ?
                                        <FilterActiveIcon />
                                        :
                                        <FilterIcon />
                                    }

                                </span>
                                <div className="tabelData_popup">
                                    <form>
                                        <div className="customCheck">

                                            <>
                                                <div className="customCheckBox clear_all_popup d_flex d_flex_justify_spacebt">
                                                    <p className="link" onClick={() => roleWiseFilter(null, null, true, null)}>Clear All</p>
                                                </div>
                                                {rolesType.map((item, i) => (
                                                    <div className="customCheckBox">
                                                        <input
                                                            type="checkbox"
                                                            id={item.name}
                                                            name={item.name}
                                                            value={item.value ? true : false}
                                                            checked={item.value ? true : false}
                                                            onClick={(e) => roleWiseFilter(e, i)}
                                                        />
                                                        <label htmlFor={item.name}>
                                                            <span className="check_icon d_flex">
                                                                {item.name}
                                                            </span>
                                                        </label>
                                                    </div>
                                                ))
                                                }
                                            </>
                                        </div>
                                    </form>
                                </div>
                            </th>
                            <th style={{ width: "130px" }}>
                                <span className="d_flex d_flex_align_center">
                                    Film
                                    {itemsWiseFilterData && itemsWiseFilterData.length ?
                                        <FilterActiveIcon />
                                        :
                                        <FilterIcon />
                                    }
                                </span>
                                <div className="tabelData_popup large_popup" style={{ width: "250px" }}>
                                    <form>
                                        <div className="customCheck">
                                            <>
                                                <div className="customCheckBox clear_all_popup d_flex d_flex_justify_spacebt">
                                                    <p className="link" onClick={() => itemsScreeningTypeFilter(null, null, null, true)}>Clear All</p>
                                                </div>
                                                {filmFilterType.map((item, i) => (
                                                    <div className="customCheckBox" style={{ height: "auto" }}>
                                                        <input
                                                            type="checkbox"
                                                            id={item.name}
                                                            name={item.name}
                                                            value={item.value ? true : false}
                                                            checked={item.value ? true : false}
                                                            onClick={(e) => itemsScreeningTypeFilter(e, i)}
                                                        />
                                                        <label htmlFor={item.name} style={{ height: "auto" }}>
                                                            <span className="check_icon d_flex">
                                                                {item.name}
                                                            </span>
                                                        </label>
                                                    </div>
                                                ))
                                                }
                                            </>
                                        </div>
                                    </form>
                                </div>
                            </th>
                            <th style={{ width: "150px" }}>
                                <span className="d_flex d_flex_align_center">
                                    Screening Type
                                    {screeningTypeFilterData && screeningTypeFilterData.length ?
                                        <FilterActiveIcon />
                                        :
                                        <FilterIcon />
                                    }
                                </span>
                                <div className="tabelData_popup">
                                    <form>
                                        <div className="customCheck">
                                            <>
                                                <div className="customCheckBox clear_all_popup d_flex d_flex_justify_spacebt">
                                                    <p className="link" onClick={() => screeningOnlineTypeFilter(null, null, null, true)}>Clear All</p>
                                                </div>
                                                {screeningOnlineType.map((item, i) => (
                                                    <div className="customCheckBox">
                                                        <input
                                                            type="checkbox"
                                                            id={item.name}
                                                            name={item.name}
                                                            value={item.value ? true : false}
                                                            checked={item.value ? true : false}
                                                            onClick={(e) => screeningOnlineTypeFilter(e, i)}
                                                        />
                                                        <label htmlFor={item.name}>
                                                            <span className="check_icon d_flex">
                                                                {item.name}
                                                            </span>
                                                        </label>
                                                    </div>
                                                ))
                                                }
                                            </>
                                        </div>
                                    </form>
                                </div>
                            </th>
                            <th style={{ width: "130px" }}>
                                <span>Screening Date Time (MT) </span>
                            </th>
                            <th style={{ width: "150px" }}>
                                <span>First Watch Now Date Time (MT) </span>
                            </th>
                            <th style={{ width: "120px" }}>
                                <span>IP Address</span>
                            </th>
                            {/* <th style={{ width: "110px" }}>
                                <span>Vote</span>
                            </th> */}
                            <th style={{ width: "110px" }}>
                                <span>20 Min Flag</span>
                            </th>
                            <th style={{ width: "110px" }} className="text_center">
                                <span>Joined Waiting Room?</span>
                            </th>
                            <th style={{ width: "110px" }}>
                                <span>Joined QA Live?</span>
                            </th>
                            <th style={{ width: "110px" }}>
                                <span>Source</span>
                                {sourceFilterData && sourceFilterData.length ?
                                    <FilterActiveIcon />
                                    :
                                    <FilterIcon />
                                }
                                <div className="tabelData_popup">
                                    <form>
                                        <div className="customCheck">
                                            <>
                                                <div className="customCheckBox clear_all_popup d_flex d_flex_justify_spacebt">
                                                    <p className="link" onClick={() => sourceTypeFilter(null, null, null, true)}>Clear All</p>
                                                </div>
                                                {sourceType.map((item, i) => (
                                                    <div className="customCheckBox">
                                                        <input
                                                            type="checkbox"
                                                            id={item.name}
                                                            name={item.name}
                                                            value={item.value ? true : false}
                                                            checked={item.value ? true : false}
                                                            onClick={(e) => sourceTypeFilter(e, i)}
                                                        />
                                                        <label htmlFor={item.name}>
                                                            <span className="check_icon d_flex">
                                                                {item.name}
                                                            </span>
                                                        </label>
                                                    </div>
                                                ))
                                                }
                                            </>
                                        </div>
                                    </form>
                                </div>
                            </th>
                        </thead>
                        <tbody>
                            {getAllScreeningReport.map((getScreeningData, i) => {
                                return (
                                    <tr>
                                        <td style={{ width: "325px" }} className="pl_25">{getScreeningData?.userInfo?.email? getScreeningData?.userInfo?.email:getScreeningData?.user?.email}</td>
                                        <td style={{ width: "110px" }}>{getScreeningData?.userInfo?.fname? getScreeningData?.userInfo?.fname : getScreeningData?.user?.fname}</td>
                                        <td style={{ width: "110px" }}>{getScreeningData?.userInfo?.lname? getScreeningData?.userInfo?.lname : getScreeningData?.user?.lname}</td>
                                        <td style={{ width: "150px" }}> {getScreeningData?.userInfo?.role? getScreeningData?.userInfo?.role : getScreeningData?.user?.role === 'generalUser' ? 'General User' :
                                           getScreeningData?.userInfo?.role? getScreeningData?.userInfo?.role : getScreeningData?.user?.role === 'pressUser' ? 'Press User' :
                                               getScreeningData?.userInfo?.role? getScreeningData?.userInfo?.role : getScreeningData?.user?.role === 'sioUser' ? 'Industry User' :
                                                   getScreeningData?.userInfo?.role? getScreeningData?.userInfo?.role : getScreeningData?.user?.role === 'circleGuestUser' ? 'Sundance Guest' :
                                                       getScreeningData?.userInfo?.role? getScreeningData?.userInfo?.role : getScreeningData?.user?.role === 'artistUser' ? 'Artist User' : '-'} </td>
                                        <td style={{ width: "130px" }}> {getScreeningData?.filmType === 'Film' ? getScreeningData?.filmDetail?.title : getScreeningData?.filmType === 'ShortProgramme' ? getScreeningData?.shortProgrammeDetail?.name : '-'}</td>
                                        <td style={{ width: "150px" }}> {
                                            getScreeningData && getScreeningData?.isMyLibrary === true ? "My Library" :
                                            getScreeningData?.filmType === 'Film' && getScreeningData?.filmDetail?.date?.screeningType === "4" ? "Indies Series" :
                                            getScreeningData?.filmType === 'Film' && getScreeningData?.filmDetail?.date?.screeningType === "1" ? "Premiere" :
                                                getScreeningData?.filmType === 'Film' && getScreeningData?.filmDetail?.date?.screeningType === "2" ? "Second Screening" :
                                                    getScreeningData?.filmType === 'Film' && getScreeningData?.filmDetail?.date?.screeningType === "3" ? "Award Winner" :
                                                            getScreeningData?.filmType === 'Film' && getScreeningData?.filmDetail?.date?.screeningType === "5"  ? 'Shorts' : getScreeningData?.filmType === 'Film' && getScreeningData?.filmDetail?.category.type === 3 ? 'Indies Series' : getScreeningData?.filmType === 'Film' && getScreeningData?.filmDetail?.category.type === 2 ? 'Shorts' :
                                                            getScreeningData?.filmType === 'Film' && getScreeningData?.filmDetail?.category.type === 1 ? 'Premiere' : '-'                                                            
                                        } </td>
                                        {getScreeningData?.filmType === 'Film' && <td style={{ width: "120px" }}>
                                            {moment(getScreeningData?.filmDetail?.date?.date).tz("US/Mountain").format('MM/DD/YYYY')} {moment(getScreeningData?.filmDetail?.date?.date).tz("US/Mountain").format('h:mm A')}
                                        </td>
                                        }
                                        {getScreeningData?.filmType === 'ShortProgramme' && <td style={{ width: "120px" }}>
                                            {moment(getScreeningData?.shortProgrammeDetail?.date).tz("US/Mountain").format('MM/DD/YYYY')} {moment(getScreeningData?.shortProgrammeDetail?.date).tz("US/Mountain").format('h:mm A')}
                                        </td>
                                        }


                                        <td style={{ width: "110px" }}> {moment(getScreeningData?.time).tz("US/Mountain").format('MM/DD/YYYY')} {moment(getScreeningData?.time).tz("US/Mountain").format('h:mm A')} </td>
                                        <td style={{ width: "110px" }}> {getScreeningData?.ip ? getScreeningData?.ip : '-'} </td>
                                        {/* <td style={{ width: "110px" }}>
                                            <span> {getScreeningData?.filmDetail?.date?.screeningType === "1" && getScreeningData?.rating?.rating ? getScreeningData?.rating?.rating + '/5' :
                                                getScreeningData?.filmDetail?.date?.screeningType === "2"
                                                    || getScreeningData?.filmDetail?.date?.screeningType === "3"
                                                    || getScreeningData?.filmDetail?.date?.screeningType === ""
                                                    || getScreeningData?.filmType === 'ShortProgramme' ? 'NA' : '-'} </span>
                                        </td> */}
                                        <td style={{ width: "110px" }}><span>{getScreeningData?.twentyMinFlag === true ? 'Y' : getScreeningData?.twentyMinFlag === false ? 'N' : '-'}</span></td>
                                        <td style={{ width: "110px" }}>
                                            <span>{getScreeningData?.filmDetail?.date?.screeningType === "1" && getScreeningData?.waitingRoom === true ? 'Y' :
                                                getScreeningData?.filmDetail?.dateTime?.screeningType === "1" && getScreeningData?.waitingRoom === false ? 'N' :
                                                    getScreeningData?.filmDetail?.date?.screeningType === "2"
                                                        || getScreeningData?.filmDetail?.date?.screeningType === "3"
                                                        || getScreeningData?.filmDetail?.date?.screeningType === ""
                                                        || getScreeningData?.filmType === 'ShortProgramme' ? 'NA' : '-'}
                                            </span>
                                        </td>
                                        <td style={{ width: "110px" }}><span>{getScreeningData?.filmDetail?.date?.screeningType === "1" && getScreeningData?.QAlive === true ? 'Y' :
                                            getScreeningData?.filmDetail?.dateTime?.screeningType === "1" && getScreeningData?.QAlive === false ? 'N' :
                                                getScreeningData?.filmDetail?.date?.screeningType === "2"
                                                    || getScreeningData?.filmDetail?.date?.screeningType === "3"
                                                    || getScreeningData?.filmDetail?.date?.screeningType === ""
                                                    || getScreeningData?.filmType === 'ShortProgramme' ? 'NA' : '-'}</span></td>
                                        <td style={{ width: "110px" }}>{getScreeningData?.isOTT === true ? 'OTT' : 'Web'}</td>
                                    </tr>
                                )
                            })}

                        </tbody>
                    </table>
                </div>
                {/* Pagination View Display */}
                {getAllScreeningReport.length && getAllScreeningReport ? (
                    <div className="custom-pagination">
                        <ReactPaginate
                            previousLabel={""}
                            nextLabel={""}
                            breakLabel={"..."}
                            breakClassName={"break-me"}
                            pageCount={this.state.pageCount}
                            marginPagesDisplayed={2}
                            pageRangeDisplayed={5}
                            onPageChange={this.props.handlePageClick}
                            containerClassName={"pagination"}
                            subContainerClassName={"pages pagination"}
                            activeClassName={"active"}
                            forcePage={this.state.currentPage}
                        />
                    </div>
                ) : (
                    ""
                )}

                {this.state.loaderFlag ? (
                    <Loader />
                ) : (
                    ""
                )}
            </>


        )
    }
}
